module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/ai23-91353961de2d109a7ff583f460707109.jpg";